import type { Parser, Values } from "nuqs";

export function formatNuqsState(
  state: Values<{
    [x: string]: Parser<string>;
  }>
): Record<string, string[]> {
  const formatted = {} as Record<string, string[]>;
  for (const [type, value] of Object.entries(state)) {
    if (value) {
      formatted[type] = value
        .split(",")
        .map((v) => `${type}:${v.replace(/_IN_/g, ",")}`);
    }
  }

  return formatted;
}
